var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_2328)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_2328)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.972 20.9402H28.477C27.0177 20.9402 25.7422 22.1933 25.7422 23.627V55.8639C25.7422 57.2961 27.0177 58.5507 28.477 58.5507H52.175C53.6328 58.5507 54.9098 57.2976 54.9098 55.8639V31.6858L48.529 27.2089L43.972 20.9402Z",
    fill: "#A6A6C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6801 48.6988H47.618V46.9086H36.6801V48.6988ZM36.6801 37.058V38.8482H47.618V37.058H36.6801ZM35.0386 37.9546C35.0386 38.6707 34.4919 39.3868 33.5808 39.3868C32.6697 39.3868 32.123 38.8497 32.123 37.9546C32.123 37.0595 32.6697 36.5225 33.5808 36.5225C34.4919 36.5225 35.0386 37.237 35.0386 37.9546ZM35.0386 42.9686C35.0386 43.6847 34.4919 44.4008 33.5808 44.4008C32.6697 44.4008 32.123 43.8637 32.123 42.9686C32.123 42.0736 32.6697 41.5365 33.5808 41.5365C34.4919 41.5365 35.0386 42.2526 35.0386 42.9686ZM35.0386 47.8037C35.0386 48.5197 34.4919 49.2358 33.5808 49.2358C32.6697 49.2358 32.123 48.6988 32.123 47.8037C32.123 46.9086 32.6697 46.3715 33.5808 46.3715C34.4919 46.3715 35.0386 47.0876 35.0386 47.8037ZM36.6801 44.2218H47.618V42.4301H36.6801V44.2218Z",
    fill: "#F2F2F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7007 30.9697L54.9097 40.8203V31.6858L44.7007 30.9697Z",
    fill: "url(#paint2_linear_852_2328)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9722 20.9402V28.999C43.9722 30.4312 45.2477 31.6858 46.707 31.6858H54.91L43.9722 20.9402Z",
    fill: "#F2F2F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.477 20.9402C27.0177 20.9402 25.7422 22.1933 25.7422 23.627V23.806C25.7422 22.3723 27.0177 21.1192 28.477 21.1192H43.972V20.9402H28.477Z",
    fill: "#F2F2F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.175 58.3701H28.477C27.0177 58.3701 25.7422 57.117 25.7422 55.6833V55.8624C25.7422 57.2945 27.0177 58.5492 28.477 58.5492H52.175C53.6328 58.5492 54.9098 57.296 54.9098 55.8624V55.6833C54.9098 57.117 53.6328 58.3701 52.175 58.3701Z",
    fill: "#C0C0D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7051 31.6858C45.2473 31.6858 43.9702 30.4327 43.9702 28.999V29.178C43.9702 30.6102 45.2458 31.8648 46.7051 31.8648H54.9081V31.6858H46.7051Z",
    fill: "#C0C0D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.972 20.9402H28.477C27.0177 20.9402 25.7422 22.1933 25.7422 23.627V55.8639C25.7422 57.2961 27.0177 58.5507 28.477 58.5507H52.175C53.6328 58.5507 54.9098 57.2976 54.9098 55.8639V31.6858L43.972 20.9402Z",
    fill: "url(#paint3_radial_852_2328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_2328",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_2328",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_852_2328",
    x1: 49.8045,
    y1: 31.7537,
    x2: 49.8045,
    y2: 40.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B92",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311B92",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_852_2328",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.6649 21.9439) scale(376.227 369.612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg21);
export default __webpack_public_path__ + "static/media/productivityimg21.7569d8bc15c1a2ee0f07b6a9f143dbb5.svg";
export { ForwardRef as ReactComponent };